// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1bBla","buttons":"PendingPaymentAlert_buttons__OSz9C"};